var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoomCalendar01 = function SvgBoomCalendar01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boom_calendar-01_svg2__a",
    x1: -7.91,
    x2: 219.12,
    y1: 114.31,
    y2: 86.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#boom_calendar-01_svg2__a",
    id: "boom_calendar-01_svg2__b",
    x1: 45.88,
    x2: 160.84,
    y1: 143.14,
    y2: 129.12
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M172.72 18.97h-5.48v-6.04c0-7.1-5.78-12.88-12.88-12.88h-3.95c-7.1 0-12.88 5.78-12.88 12.88v6.04H62.1v-6.04C62.1 5.83 56.32.05 49.22.05h-3.95c-7.1 0-12.88 5.78-12.88 12.88v6.04h-5.11C12.24 18.97 0 31.2 0 46.25v126.42c0 15.04 12.24 27.28 27.28 27.28h145.44c15.04 0 27.28-12.24 27.28-27.28V46.25c0-15.04-12.24-27.28-27.28-27.28m-28.63-6.04c0-3.48 2.83-6.3 6.3-6.3h3.96c3.48 0 6.3 2.83 6.3 6.3v20.56c0 3.48-2.83 6.3-6.3 6.3h-3.96c-3.48 0-6.3-2.83-6.3-6.3zm-105.14 0c0-3.48 2.83-6.3 6.3-6.3h3.96c3.48 0 6.3 2.83 6.3 6.3v20.56c0 3.48-2.83 6.3-6.3 6.3h-3.96c-3.48 0-6.3-2.83-6.3-6.3zm133.77 180.45H27.27c-11.42 0-20.71-9.29-20.71-20.71V79.7h186.86v92.96h.01c0 11.43-9.29 20.72-20.71 20.72m20.73-120.24H6.57V46.25c0-11.42 9.29-20.71 20.71-20.71h5.11v7.94c0 7.1 5.78 12.88 12.88 12.88h3.96c7.1 0 12.88-5.78 12.88-12.88v-7.94h75.43v7.94c0 7.1 5.78 12.88 12.88 12.88h3.96c7.1 0 12.88-5.78 12.88-12.88v-7.94h5.48c11.42 0 20.71 9.29 20.71 20.71z",
    style: {
      fill: "url(#boom_calendar-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.62 110.03c-12.63-2.73-22.28 2.53-29.17 10.69-.42.5-.58 1.76-.25 2.29 1.72 2.77 3.63 5.43 4.79 7.12 2.88-2.38 5.51-4.77 8.35-6.86 7.2-5.32 17.54-3.92 22.91 2.97s4.37 16.99-2.25 22.75c-6.61 5.74-16.43 5.7-22.74-1.06-4.7-5.04-8.22-11.17-12.35-16.75-3.34-4.52-6.5-9.23-10.3-13.34-4.98-5.39-11.47-8.2-18.86-8.49-13.05-.5-24.88 8.7-27.56 21.31-2.74 12.9 3.78 25.81 15.58 30.84 12.34 5.26 27.12.82 34.61-10.51-1.95-2.96-3.94-5.99-6.13-9.31-1.6 1.84-2.87 3.53-4.38 4.98-1.58 1.52-3.26 3.03-5.13 4.15-6.06 3.64-13.84 2.76-19.1-1.94-5.23-4.68-6.85-12.63-3.88-19.14 2.95-6.48 9.69-10.25 16.67-9.6 7.13.67 11.5 5.25 15.25 10.58s6.88 11.1 10.83 16.26c3.26 4.25 6.86 8.49 11.1 11.69 8.93 6.72 21.02 6.7 30.21.78 9.39-6.04 14.12-17 12.13-28.13-1.85-10.35-10.13-19.06-20.36-21.27Z",
    style: {
      fill: "url(#boom_calendar-01_svg2__b)"
    }
  }));
};
export default SvgBoomCalendar01;